var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"labeled-text-form",class:{
    'labeled-text-form--wrap': _vm.isWrap,
    'labeled-text-form--no-copy': _vm.isNoCopy,
  }},[_c('p',{staticClass:"caption-medium"},[_vm._v(_vm._s(_vm.label))]),_c('p',{staticClass:"labeled-text-form__text",style:({ color: _vm.color })},[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }